import { EXTERNAL_SOURCE_PBP } from './constants';

interface ClinicLinkSource {
  externalBookingUrl?: string | null;
  externalSource?: string | null;
}

/** External clinics (own booking URL or scraped) leave Bounce; everything else opens in-app. */
export const getClinicLinkType = (clinic: ClinicLinkSource): 'internal' | 'external' =>
  clinic.externalBookingUrl?.trim() || clinic.externalSource === EXTERNAL_SOURCE_PBP
    ? 'external'
    : 'internal';
